import { Route } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'devices',
  },
  {
    path: 'callback',
    loadComponent: () => import('./callback-page').then((c) => c.CallbackPage),
  },
  {
    path: 'devices',
    canActivate: [autoLoginPartialRoutesGuard],
    canActivateChild: [autoLoginPartialRoutesGuard],
    loadChildren: () =>
      import('@shareview-health/configuration/registration').then((m) => m.configurationFeatureRegistrationRoutes),
  },
  { path: 'unauthorized', redirectTo: '', pathMatch: 'full' },
];
